export default "__VITE_ASSET__be471567__"